<template>
  <div class="px-2">
    <h3 class="anomalies-list">Anomalies</h3>
    machine id: {{ machineId }}
    organization id: {{ organizationId }}
    <div class="flex flex-col gap-2" v-if="data && data.length > 0">
      <div v-for="item in data" class="card w-full shadow rounded-md border border-base-100">
        <div class="flex items-center w-full justify-between gap-2">
          <span>{{ item.t }}</span>
          <span class="text-xs">{{ item.created_at }}</span>
        </div>
        <div class="card-body">

          {{item.description}}
          {{item.details}}
        </div>
      </div>
    </div>
  </div>

</template>
<script setup>
import {ref} from "vue";
import {fetchSignals} from "~/lib/api/machine_signals";
import {fetchDowntimes} from "~/lib/api/machine_downtimes";
import {fetchIncidents} from "~/lib/api/machine_incidents";

let props = defineProps({
  machineId: String,
  organizationId: String,
})
const {machineId, organizationId} = props;
let data = ref([]);
Promise.all([
      fetchSignals(organizationId, machineId),
      fetchDowntimes(organizationId, machineId),
      fetchIncidents(organizationId, machineId)
    ]
).then(([signals, downtimes, incidents]) => {
  data.value = [
    ...signals.data.map(e => {
      e.t = "signal";
      return e;
    }),
    ...downtimes.data.map(e => {
      e.t = "downtime";
      return e;
    }),
    ...incidents.data.map(e => {
      e.t = "incident";
      return e;
    })
  ];
});

</script>